import { searchItemView } from './utils'

export function select(
  definition,
  absolutePoint,
  itemViews,
  interaction,
  methods,
) {
  itemViews.forEach(e => {
    e.type = 'default'
  })

  const filteredItems = itemViews
    .filter(itemView => !itemView.deleted)
    .sort((a, b) => a.position - b.position)

  //search selected itemView
  const currentItemView = searchItemView(
    filteredItems,
    definition.selectableEntities,
    definition.hitDetection,
    absolutePoint,
  )

  if (!currentItemView) return null

  currentItemView.type = 'selected'

  //move selected itemView to top
  if (definition.bringToFrontAfterSelect) {
    let maxPosition = 0
    filteredItems.forEach(item => {
      if (item.position > maxPosition) maxPosition = item.position
    })
    currentItemView.position = maxPosition + 1
  }

  //user's callback
  const onSelect = definition.onSelect
  if (onSelect && methods.getItem) {
    onSelect(methods.getItem(currentItemView))
  }

  //stop checking of interations
  return {
    itemViews: [...itemViews],
    currentItemView,
  }
}



// WEBPACK FOOTER //
// ./src/drawing/core/mouseDown/select.js